<template>
  <div class="schema-page">
    <div class="schema-page__inner">
      <PrimeToast />

      <SchemaDrivenForm
        :schema="applicationSchema"
        @submitted="handleSubmitted"
      />
    </div>
  </div>
</template>

<script>
import SchemaDrivenForm from '@/components/SchemaDrivenForm.vue';
import { applicationSchema } from '@/schemas/applicationSchema';

export default {
  name: 'SchemaFormPage',
  components: {
    SchemaDrivenForm
  },
  data() {
    return {
      applicationSchema
    };
  },
  methods: {
    handleSubmitted() {
      this.$toast.add({
        severity: 'success',
        summary: 'Submitted',
        detail: 'Form submitted successfully',
        life: 3000
      });
    }
  }
};
</script>

<style scoped>
.schema-page {
  min-height: 100vh;
  background: #e9ebec;
  padding: 24px 12px;
}

.schema-page__inner {
  width: min(100%, 960px);
  margin: 0 auto;
}
</style>
